// Washington State Parks - Complete List
export const waStateParks = [
  "Alta Lake State Park",
  "Anderson Lake State Park",
  "Battle Ground Lake State Park",
  "Bay View State Park",
  "Beacon Rock State Park",
  "Belfair State Park",
  "Birch Bay State Park",
  "Blake Island State Park",
  "Bogachiel State Park",
  "Bridgeport State Park",
  "Brooks Memorial State Park",
  "Camano Island State Park",
  "Cape Disappointment State Park",
  "Centennial Trail State Park",
  "Chief Timothy State Park",
  "Columbia Hills State Park",
  "Columbia Plateau Trail State Park",
  "Conconully State Park",
  "Crawford State Park",
  "Crow Butte State Park",
  "Curlew Lake State Park",
  "Dash Point State Park",
  "Deception Pass State Park",
  "Dosewallips State Park",
  "Doug's Beach State Park",
  "Dry Falls State Park",
  "Federation Forest State Park",
  "Fields Spring State Park",
  "Flaming Geyser State Park",
  "Fort Casey State Park",
  "Fort Columbia State Park",
  "Fort Ebey State Park",
  "Fort Flagler State Park",
  "Fort Simcoe State Park",
  "Fort Townsend State Park",
  "Fort Worden State Park",
  "Ginkgo Petrified Forest State Park",
  "Goldendale Observatory State Park",
  "Grayland Beach State Park",
  "Green River Gorge State Park",
  "Griffiths-Priday State Park",
  "Hope Island State Park (Mason County)",
  "Hope Island State Park (Skagit County)",
  "Ike Kinswa State Park",
  "Illahee State Park",
  "Iron Horse State Park",
  "Jarrell Cove State Park",
  "Joemma Beach State Park",
  "Joseph Whidbey State Park",
  "Kanaskat-Palmer State Park",
  "Kinney Point State Park",
  "Klickitat Trail State Park",
  "Kopachuck State Park",
  "Lake Chelan State Park",
  "Lake Easton State Park",
  "Lake Sammamish State Park",
  "Lake Sylvia State Park",
  "Lake Wenatchee State Park",
  "Larrabee State Park",
  "Leadbetter Point State Park",
  "Lewis and Clark State Park",
  "Lewis and Clark Trail State Park",
  "Lime Kiln Point State Park",
  "Lincoln Rock State Park",
  "Lyons Ferry State Park",
  "Manchester State Park",
  "Maryhill State Park",
  "McMicken Island State Park",
  "Millersylvania State Park",
  "Moran State Park",
  "Moses Lake State Park",
  "Mount Pilchuck State Park",
  "Mount Spokane State Park",
  "Mystery Bay State Park",
  "Nolte State Park",
  "Ocean City State Park",
  "Olallie State Park",
  "Old Fort Townsend State Park",
  "Olmstead Place State Park",
  "Osoyoos Lake State Park",
  "Pacific Beach State Park",
  "Pacific Pines State Park",
  "Palouse Falls State Park",
  "Paradise Point State Park",
  "Peace Arch State Park",
  "Pearrygin Lake State Park",
  "Penrose Point State Park",
  "Peshastin Pinnacles State Park",
  "Pleasant Harbor State Park",
  "Potholes State Park",
  "Potlatch State Park",
  "Rasar State Park",
  "Reed Island State Park",
  "Riverside State Park",
  "Rockport State Park",
  "Sacajawea State Park",
  "Saint Edward State Park",
  "Saltwater State Park",
  "Scenic Beach State Park",
  "Schafer State Park",
  "Seaquest State Park",
  "Sequim Bay State Park",
  "Shine Tidelands State Park",
  "South Whidbey State Park",
  "Spencer Spit State Park",
  "Spokane River Centennial Trail State Park",
  "Spring Creek Hatchery State Park",
  "Squak Mountain State Park",
  "Squilchuck State Park",
  "Steamboat Rock State Park",
  "Steptoe Battlefield State Park",
  "Steptoe Butte State Park",
  "Stretch Point State Park",
  "Stuart Island State Park",
  "Sucia Island State Park",
  "Sun Lakes-Dry Falls State Park",
  "Tolmie State Park",
  "Triton Cove State Park",
  "Turn Island State Park",
  "Twenty-Five Mile Creek State Park",
  "Twin Harbors State Park",
  "Twanoh State Park",
  "Wallace Falls State Park",
  "Wanapum State Park",
  "Wenatchee Confluence State Park",
  "Westport Light State Park",
  "Westhaven State Park",
  "Willapa Hills Trail State Park",
  "Yakima Sportsman State Park"
];
